export const stage_domain = "mycvt.com";